import { SEARCH_DELETE, SEARCHES_GET } from './actionTypes'

/**
 * Get request to API to delete a search.
 * @param {string} searchId
 */
export const deleteSearch = searchId => ({
  meta: {
    errorMessage: `Error deleting saved search. Please try again.`,
    method: 'delete',
    successMessage: `Saved search deleted.`,
    url: `/api/v1/search/${searchId}`,
  },
  type: SEARCH_DELETE,
})

/**
 * Get request to API to get all searches of a user.
 * @param {string} userId
 */
export const getUserSearches = userId => ({
  meta: { url: `/api/v1/search/${userId}` },
  type: SEARCHES_GET,
})
